import API from '../global/api';

export function pausedLoad (marina = null) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'PAUSED_LOAD',
            status: 'LOADING',
            payload: null
        })


        if(marina !== null){

            try {
  
                const data = await API.req(`/services/paused/${marina}`, 'GET');
                dispatch({
                    type: 'PAUSED_LOAD',
                    status: 'OK',
                    payload: data.result
                })
                
            } catch (err) {

                dispatch({
                    type: 'PAUSED_LOAD',
                    status: 'error',
                    payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your paused services'
                })

            }
  
        }

    }
}

export function pausedUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'PAUSED_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}